import { render, staticRenderFns } from "./map-point.vue?vue&type=template&id=a80e1750&scoped=true"
import script from "./map-point.vue?vue&type=script&lang=js"
export * from "./map-point.vue?vue&type=script&lang=js"
import style0 from "./map-point.vue?vue&type=style&index=0&id=a80e1750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80e1750",
  null
  
)

export default component.exports